var path = 'app/scripts/modules/core/src/pipeline/config/stages/wait/waitStage.html';
var html = "<div class=\"form-horizontal\">\n  <stage-config-field label=\"Wait Time (seconds)\" field-columns=\"6\">\n    <number-input model=\"stage.waitTime\"></number-input>\n  </stage-config-field>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/pipeline/config/stages/wait/waitStage.html
// module id = 1017
// module chunks = 0